import {Store, Module, ActionContext} from 'vuex';
import ListModule from '../list-module';
import ListState from '../list-state';
import Vendor from '@/store/entities/auth/Vendor';
import Ajax from '@/lib/ajaxAuthPublic';
import PageResult from '@/store/entities/page-result';

interface VendorState extends ListState<Vendor>{
    editVendor: Vendor;
    competitiveList: Array<Vendor>;
    vendor: Vendor;
}

class VendorModule extends ListModule<VendorState, any, Vendor>{
    state={
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<Vendor>(),
        competitiveList: new Array<Vendor>(),
        loading: false,
        editVendor: new Vendor(),
        vendor: new Vendor()
    }
    actions={
        async getCompetitiveList(context: ActionContext<VendorState, any>){
            let data = {
                isCompetitive: true,
                maxResultCount: 5
            };
            context.state.loading = true;
            let reponse = await Ajax.get('/Vendor/GetList', { params: data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<Vendor>;
            context.state.totalCount = page.totalCount;
            context.state.competitiveList = page.items;
        },
        async register(context: ActionContext<VendorState, any>, payload: any){
            await Ajax.post('/Vendor/register', payload.data);
        },
        async update(context: ActionContext<VendorState, any>, payload: any){
            await Ajax.put('/Vendor/Update', payload.data);
        },
        async getByNo(context: ActionContext<VendorState, any>, payload: any){
            let reponse = await Ajax.get('/Vendor/GetByNo?no=' + payload.data);
            context.state.vendor = reponse.data.result as Vendor; // set value for editing.
            return reponse.data.result as Vendor;
        },
        async getByUserNo(context: ActionContext<VendorState, any>, payload: any){
            let reponse = await Ajax.get('/Vendor/getByUserNo?userNo=' + payload.data);
            return reponse.data.result as Vendor;
        },
        async existsDisplayName(context: ActionContext<VendorState, any>, payload: any){
            let reponse = await Ajax.get('/Vendor/ExistsDisplayName?displayName=' + payload.data);
            return reponse.data.toString().toLowerCase() === 'true';
        },
    };
    mutations={
        setCurrentPage(state: VendorState, page: number){
            state.currentPage = page;
        },
        setPageSize(state: VendorState, pagesize: number){
            state.pageSize = pagesize;
        }
    }
}
const vendorModule = new VendorModule();
export default vendorModule;